import styled from "styled-components";
import { tokens } from "../../public/tokens";
import { sizes } from "./SelectDropdown.styles";

/*
 * Only the two pieces that genuinely differ from SelectDropdown live here (a
 * text-input trigger instead of a read-only value box). Everything else
 * (dropdown list/items, label row, messages, clear button...) is reused
 * directly from SelectDropdown.styles.js by the component, not duplicated.
 */

export const StyledTriggerBox = styled.div(({ $size = "lg", $disabled = false, $error = false }) => {
    const size = sizes[$size] || sizes.lg;

    return {
        width: "100%",
        height: size.height,
        minHeight: size.height,
        padding: size.padding,
        backgroundColor: $disabled ? tokens.colors.neutral.grey["100"] : tokens.colors.surfaces["container-background"],
        border: `${tokens.globals["spacing-px"]} solid ${$error ? tokens.colors.ui.destructive : tokens.colors.surfaces["border-divider"]}`,
        borderRadius: size.borderRadius,
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        gap: tokens.globals["spacing-1-5"],
        opacity: $disabled ? 0.6 : 1,
        boxSizing: "border-box",
        transition: "border-color 0.15s ease-in-out",

        "&:hover": $disabled ? {} : {
            borderColor: $error ? tokens.colors.ui.destructive : tokens.colors.neutral.grey["500"],
        },

        "&:focus-within": $disabled ? {} : {
            borderColor: $error ? tokens.colors.ui.destructive : tokens.colors.ui.ring,
        },
    };
});

export const StyledSearchInput = styled.input({
    flex: "1 1 0",
    minWidth: 0,
    border: "none",
    outline: "none",
    background: "transparent",
    padding: 0,
    color: tokens.colors.text.primary,
    fontFamily: tokens.typography.fontFamilies["albert-sans"],
    fontSize: tokens.typography.fontSize["lg-14px"],
    lineHeight: "20px",

    "&::placeholder": {
        color: tokens.colors.text.secondary,
        fontWeight: tokens.typography.fontWeights.regular,
    },

    "&:disabled": {
        cursor: "not-allowed",
    },
});

export const StyledOptionAvatar = styled.span({
    flexShrink: 0,
});
